import { apiTransformer } from 'utils';

export const competitionToApiTransformer = values => {
    return {...apiTransformer(values, ['location', 'rule', 'secretary', 'fee', 'discipline'])};
}
